module.exports = __webpack_public_path__ + "static/img/购物车暂无icon@2x@3x.3dc810b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/购物车/购物车暂无icon@2x@3x.png
// module id = aEx5
// module chunks = 192